import BannerPolitica from '../components/bannerPolitica'
import Politica from '../components/politica'
import Rodape from '../components/rodape'

export default function PoliticaPrivacidade() {
  return (
    <>
      <BannerPolitica />
      <Politica />
      <Rodape />
    </>
  )
}
